import { useState } from 'react';
import { navItems } from '@/mocks/siteContent';

export default function Masthead() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200 bg-background-50/90 backdrop-blur">
      {/* issue strip */}
      <div className="border-b border-background-200">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-2 md:px-6">
          <p className="text-[11px] text-foreground-500">
            本页为《五一网传消息求证档案》2026 年 05 月期
          </p>
          <p className="hidden items-center gap-2 text-[11px] text-foreground-600 sm:flex">
            <span className="inline-flex h-1.5 w-1.5 rounded-full bg-primary-500" />
            台账持续更新 · 结论按日期留档
          </p>
        </div>
      </div>

      {/* masthead row */}
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 md:px-6 md:py-5">
        <a href="#top" className="group flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded bg-primary-600 text-background-50">
            <i className="ri-quill-pen-line text-lg" aria-hidden="true" />
          </span>
          <span className="leading-none">
            <span className="block font-heading text-2xl font-black tracking-wide text-foreground-950">
              五一爆料
            </span>
            <span className="mt-1 block font-label text-[10px] tracking-[0.3em] text-foreground-500">
              网传消息 · 求证档案
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#faq"
            className="hidden whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 sm:inline-flex"
          >
            如何求证
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md bg-background-100 text-foreground-800 md:hidden"
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-xl`} aria-hidden="true" />
          </button>
        </div>
      </div>

      {/* mobile panel */}
      {open ? (
        <nav className="border-t border-background-200 px-4 py-3 md:hidden" aria-label="移动端导航">
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href="#faq"
                onClick={() => setOpen(false)}
                className="mt-1 block rounded-md bg-foreground-950 px-3 py-2.5 text-center text-sm font-medium text-background-50"
              >
                如何求证
              </a>
            </li>
          </ul>
        </nav>
      ) : null}
    </header>
  );
}